import { connect } from "react-redux";
import React, { useState, useMemo, useEffect } from "react";
import ReactTable from 'react-table';
import { Row, Col, Button, Input, Container, Card, Label, CardBody } from "reactstrap";

// import ProductDetailsAboveThousand from "./ProductDetailsAboveThousand";



function AssetsProductListGridView(props) {
    const [searchText, setSearchText] = useState("");

    const filteredData = useMemo(() => {
        const data = props.storeProducts || [];
        if (!data.length) return [];
    
        // --- SEARCH FILTER ---
        const lower = searchText.toLowerCase();
    
        const searched = !searchText ? data : data.filter(item =>
            (item.parentProduct || "").toLowerCase().includes(lower) ||
            (item.asin || "").toLowerCase().includes(lower) ||
            (item.productTitle || "").toLowerCase().includes(lower) ||
            String(item.ratingVotes || "").includes(lower) ||
            String(item.itemRating || "").includes(lower)
        );
    
        // --- GROUPING LOGIC ---
    
        const parents = [];
        const childrenMap = {};
        const orphans = [];
    
        searched.forEach(item => {
    
            const parent = item.parentProduct;
            const asin = item.asin;
    
            // Parent product
            if (item.isParentProduct || parent === asin) {
                parents.push(item);
            }
    
            // Child product
            else if (parent) {
                if (!childrenMap[parent]) childrenMap[parent] = [];
                childrenMap[parent].push(item);
            }
    
            // Orphan product
            else {
                orphans.push(item);
            }
        });
    
        // --- BUILD FINAL ORDER ---
        const finalList = [];
    
        parents.forEach(parent => {
            finalList.push(parent);
    
            if (childrenMap[parent.asin]) {
                finalList.push(...childrenMap[parent.asin]);
            }
        });
    
        // add remaining children whose parent not found
        Object.keys(childrenMap).forEach(parentAsin => {
            const parentExists = parents.find(p => p.asin === parentAsin);
            if (!parentExists) {
                orphans.push(...childrenMap[parentAsin]);
            }
        });
    
        // orphans always last
        finalList.push(...orphans);
    
        return finalList;
    
    }, [props.storeProducts, searchText]);

    const columns = [
 
        {
            Header: 'Parent Asin',
            accessor: 'parentProduct',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Variants',
            accessor: 'asset_variants',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0" >{cellInfo.original.asin== cellInfo.original.parentProduct?cellInfo.value:''}</p>
                </div>
            )
        },
        {
            Header: 'Child Asin',
            accessor: 'asin',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                    <p className=" m-0 " >{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Title',
            accessor: 'productTitle',
            Cell: ({ original }) => (
                <div
                    className="d-flex justify-content-start w-100"
                    style={{
                        cursor: original.isParentProduct ? "default" : "pointer",
                        color: original.isParentProduct ? "#4f4d4d" : "#007bff",
                    }}
                    onClick={() => {
                        if (!original.isParentProduct && props.setProductDetails) {
                            props.setProductDetails(original);
                        }
                    }}
                >
                    <p className="m-0">{original.productTitle}</p>
                </div>
            )
        },
        {
            Header: 'Media',
            accessor: 'asset_media_count',
            width:80,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                {cellInfo.value > 0 ? (
                <p className="m-0 assets-products-count-capsule">{cellInfo.value}</p> ) : null}
                </div>
            )
        },
        {
            Header: 'Documents',
            accessor: 'asset_document_count',
            width:120,
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
                {cellInfo.value > 0 ? (
                <p className="m-0 assets-products-count-capsule">{cellInfo.value} </p> ) : null}
                </div>
            )
        },
          

    ]   
    return (
        <>
            <Row>
            <Col md={12} className="d-flex justify-content-end">
            <div style={{ width: "300px" }}>
                <Input
                    type="text"
                    placeholder="Search product by Title, ASIN or SKU"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                />
            </div>
        </Col>

                <Col md={12}>

                    <ReactTable
                        data={filteredData}
                        columns={columns}
                        className="-fixed -highlight -striped mt-2"
                        getTheadProps={() => {
                            return {
                                style: {
                                    overflowY: "hidden",
                                    background: "#B1FA63",
                                    color: "#243837",
                                },
                            };
                        }}
                        getTrProps={(state, rowInfo) => {
                           
                            if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct
                            ) {
                              return {
                                style: {
                                  backgroundColor: '#dfd7ff', 
                                },
                              };
                            }
                            return {};
                          }}
                        defaultPageSize={10}
                        noDataText={"No Data Found."}
                    />
                </Col>

            </Row>



        </>

    )
    
}
const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        childProducts: state.accountOverview.store.childProducts,
        status: state.loggedUser.status,
        storeOverview: state.accountOverview.store.storeOverview,
        adProfiles: state.accountOverview.landing.adProfiles,
        weeklyReport: state.accountOverview.store.weeklyReport,
        ProductPerformanceReport: state.accountOverview.store.ProductPerformanceReport,
        TargetPerformanceReport: state.accountOverview.store.TargetPerformanceReport,
        StoreOverviewReport: state.accountOverview.store.StoreOverviewReport,
        WeeklySalesReport: state.accountOverview.store.WeeklySalesReport,
        SalesTrendsReport: state.accountOverview.store.SalesTrendsReport,
        WeeklySearchTermReport: state.accountOverview.store.WeeklySearchTermReport,
        CampaignPerformanceReport: state.accountOverview.store.CampaignPerformanceReport,

        storeLoading: state.accountOverview.store.loading,
        status: state.accountOverview.store.status,
        UserPermission: state.accountOverview.store.StoreUserPermission,
        error: state.loggedUser.error,
        newUser: state.loggedUser.newUser,
        needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
        user: state.LWA.user,
        isAuth: state.LWA.isAuth,
        enableMobileMenu: state.theme.enableMobileMenu,
        enableClosedSidebar: state.theme.enableClosedSidebar,
        storeProducts: state.accountOverview.store.storeProducts,
        parentProducts: state.accountOverview.store.parentProducts,
        orphanProducts: state.accountOverview.store.orphanProducts,
        ProductTargetingReport: state.accountOverview.store.ProductTargetingReport,

        storeCampaigns: state.accountOverview.store.storeCampaigns,
        unclaimedCampaigns: state.accountOverview.store.unclaimedCampaigns,
        metricData: state.accountOverview.store.metricData,
        linkedToMRP: state.accountOverview.store.storeOverview.linkedToMRP,
    };
}
export default connect(mapStateToProps)(AssetsProductListGridView);